var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 62,
    viewBox: "0 0 148 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_8786_52669)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 148,
    height: 48,
    rx: 6,
    fill: "#FE8C48"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7951 34.44V37.848H46.2911V41.016H40.7951V44.712H47.0111V48H36.6911V31.152H47.0111V34.44H40.7951ZM66.7635 34.464C68.4275 34.464 69.7475 34.968 70.7235 35.976C71.7155 36.984 72.2115 38.384 72.2115 40.176V48H68.1315V40.728C68.1315 39.864 67.8995 39.2 67.4355 38.736C66.9875 38.256 66.3635 38.016 65.5635 38.016C64.7635 38.016 64.1315 38.256 63.6675 38.736C63.2195 39.2 62.9955 39.864 62.9955 40.728V48H58.9155V40.728C58.9155 39.864 58.6835 39.2 58.2195 38.736C57.7715 38.256 57.1475 38.016 56.3475 38.016C55.5475 38.016 54.9155 38.256 54.4515 38.736C54.0035 39.2 53.7795 39.864 53.7795 40.728V48H49.6755V34.608H53.7795V36.288C54.1955 35.728 54.7395 35.288 55.4115 34.968C56.0835 34.632 56.8435 34.464 57.6915 34.464C58.6995 34.464 59.5955 34.68 60.3795 35.112C61.1795 35.544 61.8035 36.16 62.2515 36.96C62.7155 36.224 63.3475 35.624 64.1475 35.16C64.9475 34.696 65.8195 34.464 66.7635 34.464ZM79.1858 36.504C79.5858 35.88 80.1378 35.376 80.8418 34.992C81.5458 34.608 82.3698 34.416 83.3138 34.416C84.4178 34.416 85.4178 34.696 86.3138 35.256C87.2098 35.816 87.9138 36.616 88.4258 37.656C88.9538 38.696 89.2178 39.904 89.2178 41.28C89.2178 42.656 88.9538 43.872 88.4258 44.928C87.9138 45.968 87.2098 46.776 86.3138 47.352C85.4178 47.912 84.4178 48.192 83.3138 48.192C82.3858 48.192 81.5618 48 80.8418 47.616C80.1378 47.232 79.5858 46.736 79.1858 46.128V54.384H75.0818V34.608H79.1858V36.504ZM85.0418 41.28C85.0418 40.256 84.7538 39.456 84.1778 38.88C83.6178 38.288 82.9218 37.992 82.0898 37.992C81.2738 37.992 80.5778 38.288 80.0018 38.88C79.4418 39.472 79.1618 40.28 79.1618 41.304C79.1618 42.328 79.4418 43.136 80.0018 43.728C80.5778 44.32 81.2738 44.616 82.0898 44.616C82.9058 44.616 83.6018 44.32 84.1778 43.728C84.7538 43.12 85.0418 42.304 85.0418 41.28ZM98.8348 44.52V48H96.7468C95.2588 48 94.0988 47.64 93.2668 46.92C92.4348 46.184 92.0188 44.992 92.0188 43.344V38.016H90.3868V34.608H92.0188V31.344H96.1228V34.608H98.8108V38.016H96.1228V43.392C96.1228 43.792 96.2188 44.08 96.4108 44.256C96.6028 44.432 96.9228 44.52 97.3708 44.52H98.8348ZM114.801 34.608L106.401 54.36H101.985L105.057 47.544L99.6088 34.608H104.193L107.289 42.984L110.361 34.608H114.801Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8786_52669)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    width: 8,
    height: 22,
    rx: 4,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    width: 8,
    height: 22,
    rx: 4,
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_8786_52669",
    x: 0,
    y: 14,
    width: 148,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8786_52669"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_8786_52669",
    result: "effect2_innerShadow_8786_52669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8786_52669",
    x: 43,
    y: 0,
    width: 64,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8786_52669"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySign);
export default __webpack_public_path__ + "static/media/EmptySign.20c02decd188665d73b68d2801d1b01a.svg";
export { ForwardRef as ReactComponent };